import { defineStore } from "pinia";
import { computed, ref } from "vue";
import type { Organisation, PartnerProfile } from "@/types/partner";

const emptyPartnerProfile = (): PartnerProfile => ({
    partnerBusinessName: "",
    organisations: null,
    permissions: {},
});

export const usePartnerStore = defineStore(
    "partner",
    () => {
        const partnerProfile = ref<PartnerProfile>(emptyPartnerProfile());
        const organisations = computed(
            () => partnerProfile.value.organisations,
        );

        function setPartnerProfile(profile: PartnerProfile) {
            partnerProfile.value = profile;
        }

        function setOrganisationList(value: Organisation[] | null) {
            partnerProfile.value.organisations = value;
        }

        function clearPartnerProfile() {
            partnerProfile.value = emptyPartnerProfile();
        }

        return {
            partnerProfile,
            organisations,
            setPartnerProfile,
            setOrganisationList,
            clearPartnerProfile,
        };
    },
    {
        persist: {
            pick: ["partnerProfile"],
            storage: localStorage,
        },
    },
);
